// 忘记密码
import request from '@/api'

// 提交邮箱, 并下发邮箱验证码
export async function getResetSubmitEmail(data) {
  return request({
    url: `/capi/iam-account/v1/account/email_reset/submit_email`,
    method: 'post',
    data
  })
}

// 提交验证码
export async function emailResetSubmit(data) {
  return request({
    url: `/capi/iam-account/v1/account/email_reset/submit`,
    method: 'post',
    data
  })
}

// 设置密码
export async function emailResetSetPassword(data) {
  return request({
    url: `/capi/iam-account/v1/account/email_reset/set_password`,
    method: 'post',
    data
  })
}
